import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormCompanyTimeOffType from '../general-input-form/FormCompanyTimeOffType'

const AppForm = ({
  values,
  handleSelectType,
  handleChange,
  errors,
  onDateChange,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput
          id='company_time_off_name'
          name='company_time_off_name'
          colSize='6'
          inputLabel='Time-Off Name'
          className='mb-3'
          placeholder='Enter company time off name...'
          value={values.company_time_off_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.company_time_off_name}
          invalid={errors.company_time_off_name}
        />
        <FormCompanyTimeOffType
          id='company_time_off_type'
          type={'radio'}
          colSize='6'
          className='mb-3'
          inputLabel='Time-Off Type'
          value={values.company_time_off_type}
          handleCheck={handleSelectType}
          disabled={false}
        />
        <FormDatePicker
          id='company_time_off_start_date'
          name='company_time_off_start_date'
          colSize='6'
          inputLabel='Start Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.company_time_off_start_date}
          feedbackInvalid={errors.company_time_off_start_date}
          invalid={errors.company_time_off_start_date}
        />
        <FormDatePicker
          id='company_time_off_end_date'
          name='company_time_off_end_date'
          colSize='6'
          inputLabel='End Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.company_time_off_end_date}
          feedbackInvalid={errors.company_time_off_end_date}
          invalid={errors.company_time_off_end_date}
        />
        <FormTextAreaInput
          id='company_time_off_notes'
          name='company_time_off_notes'
          colSize='6'
          inputLabel='Additional Notes'
          className='mb-3'
          placeholder='Enter company time off notes...'
          rows='6'
          value={values.company_time_off_notes}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors?.company_time_off_notes}
          invalid={errors?.company_time_off_notes}
        />
      </CRow>
    </>
  )
}

export default AppForm
